const FormField = ({ label, error, children, icon: Icon, required }) => (
  <div className="flex flex-col items-start! w-full mb-5! text-left!">
    <label className="adai-form-label">
      <span className="flex items-center gap-2">
        {Icon && <Icon size={14} className="text-slate-400" />}
        {label}
        {required && <span className="text-red-500!">*</span>}
      </span>
    </label>
    {children}
    {error && (
      <span className="text-red-500! text-xs mt-2! font-bold text-left! w-full!">
        {error.message || "This field is required"}
      </span>
    )}
  </div>
);

export default FormField;
